import { exec } from "jadelet"
export default exec(["button",{"click":{"bind":"click"},"class":[{"bind":"class"}]},[{"bind":"text"}]])